<!-- eslint-disable @angular-eslint/template/no-inline-styles -->
<nova-detail-toolbar [title]="title()" [template]="toolbarTemplate()" showBackButton="false"></nova-detail-toolbar>
@if (isLoading()) {
<mat-progress-bar mode="indeterminate"></mat-progress-bar>
}
@if (isRepipelineHeaderBannerAvailable()) {
<div>
    <div class="app-dialog-note-container">
        <div class="app-dialog-note-table">
            <div class="app-dialog-note-row">
                <div class="app-dialog-note-cell app-width-36px">
                    <div class="app-dialog-note-icon">
                        <img src="assets/images/svg/point-right.svg" class="point-right-img" alt="Contract Repipelined"
                            title="Contract Repipelined" />
                    </div>
                </div>
                <div class="app-dialog-note-cell app-v-center">
                    <span class="app-dialog-note-text">{{repipelineHeaderPreText()}} </span>
                    <span class="nova__link"
                        (click)="gotoContractProfile()"><strong>{{repipelinedDisplayedContract()}}</strong></span>
                </div>
            </div>
        </div>
    </div>
</div>
}
@if (showWizardStepper()) {
<div style="margin: 15px"
    [ngClass]="unlinkBackButtonFromBrowserActionFlag() ? 'wizard flex-row flex-row-space-between' : 'wizard flex-row'">
    <div [ngClass]="unlinkBackButtonFromBrowserActionFlag() ? '' : 'flex-20'">
        <button mat-raised-button color="default" class="wizard-back-button" [attr.data-qa-id]="backButtonQaId()"
            (click)="goToPreviousStep()">
            <mat-icon class="material-icons arrow-back">arrow_back</mat-icon>
            {{ backBtnText() }}
        </button>
    </div>
    <div [ngClass]="unlinkBackButtonFromBrowserActionFlag() ? '' : 'flex-60'" style="text-align: center">
        <p class="wizard-step-title"><strong data-qa-id="WizardTitle">STEP {{ stepIndex() }} OF {{ lastStepIndex()
                }}</strong></p>
        <p><strong data-qa-id="WizardSubTitle">{{ stepSubTitle() }}</strong></p>
    </div>
    <div [ngClass]="unlinkBackButtonFromBrowserActionFlag() ? 'next-step flex-col' : 'next-step flex-col flex-20'">
        <button mat-raised-button color="primary" class="wizard-next-button" [attr.data-qa-id]="nextButtonQaId()"
            [disabled]="!isNextButtonEnabled() || isNextButtonLoading()" (click)="goToNextStep()">
            @if (isNextButtonLoading()) {
            <mat-spinner diameter="26"></mat-spinner>
            } @else {
            {{ nextButtonText() }} <mat-icon class="material-icons arrow-back">arrow_forward</mat-icon>
            }
        </button>
        @if (isNextButton2Visible()) {
        <button mat-raised-button color="primary" class="wizard-next-button-2" [attr.data-qa-id]="nextButton2QaId()"
            [disabled]="!isNextButton2Enabled() || isNextButton2Loading()" (click)="goToNextStep2()">
            @if (isNextButton2Loading()) {
            <mat-spinner diameter="26"></mat-spinner>
            } @else {
            {{ nextButton2Text() }} <mat-icon class="material-icons arrow-back">arrow_forward</mat-icon>
            }
        </button>
        }
    </div>
</div>
}
<ng-content></ng-content>